// src/pages/questions/SelfCreateAssessmentPage3.js
import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { saveAssessment } from "../../api/questions/questionsApi";
import { backicon } from "../../assets/icons/icons";
import { IoMdArrowRoundBack } from "react-icons/io";

const SelfCreateAssessmentPage3 = () => {
  const { projectId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const {
    difficulty,
    testType,
    sections,
    questionCounts,
    totalTime,
    sectionMarks,
    marksPerQuestion,
  } = state;

  const [subjectiveQuestions, setSubjectiveQuestions] = useState(
    Array.from({ length: questionCounts.subjective }, () => ({
      difficulty: difficulty,
      question_text: "",
    }))
  );
  const [objectiveQuestions, setObjectiveQuestions] = useState(
    Array.from({ length: questionCounts.objective }, () => ({
      difficulty: difficulty,
      question_text: "",
      options: ["", "", "", ""],
      answer: "",
    }))
  );

  const backButtonHandler = () => {
    navigate(`/self-create-assessment/step1/${projectId}`);
  };

  const handleTextChange = (e, index, isSubjective) => {
    if (isSubjective) {
      setSubjectiveQuestions((prevQuestions) => {
        const updatedQuestions = [...prevQuestions];
        updatedQuestions[index].question_text = e.target.value;
        return updatedQuestions;
      });
    } else {
      setObjectiveQuestions((prevQuestions) => {
        const updatedQuestions = [...prevQuestions];
        updatedQuestions[index].question_text = e.target.value;
        return updatedQuestions;
      });
    }
  };

  const handleOptionChange = (e, questionIndex, optionIndex) => {
    setObjectiveQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions[questionIndex].options[optionIndex] = e.target.value;
      return updatedQuestions;
    });
  };

  const handleAnswerChange = (e, questionIndex) => {
    setObjectiveQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions[questionIndex].answer = e.target.value;
      return updatedQuestions;
    });
  };

  const handleSubmit = async () => {
    const payload = {
      projectId,
      difficulty,
      testType,
      sections,
      questionCounts,
      totalTime,
      anchorQuestion: null,
      subjectiveQuestions,
      objectiveQuestions,
      total_marks_per_section: {
        conversational: sectionMarks?.conversational || 0,
        subjective: sectionMarks?.subjective || 0,
        objective: sectionMarks?.objective || 0,
      },
      marks_per_question: {
        conversational: marksPerQuestion?.conversational || 0,
        subjective: marksPerQuestion?.subjective || 0,
        objective: marksPerQuestion?.objective || 0,
      },
    };

    // console.log('Payload being sent to API:', payload);

    try {
      const v = true;
      await saveAssessment(
        projectId,
        difficulty,
        testType,
        sections,
        questionCounts,
        totalTime,
        subjectiveQuestions,
        objectiveQuestions,
        null,
        sectionMarks,
        marksPerQuestion,
        v
      );
      alert("Assessment saved successfully!");
      navigate(`/projects`);
    } catch (error) {
      console.error(
        "Error saving assessment:",
        error.response?.data || error.message
      );
      alert(
        `Failed to save assessment. Error: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  const grandTotalMarks =
    (sectionMarks.subjective || 0) + (sectionMarks.objective || 0);

  return (
    <div className="w-full">
      <div className="flex justify-between items-center lg:w-7/12 md:w-9/12 w-11/12 mx-auto pt-4">
        <div className="flex items-center gap-20">
         <button
                   onClick={backButtonHandler}
                   className="group flex items-center gap-3 px-5 py-2.5 rounded-full bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold shadow-md hover:scale-105 active:scale-95 transition"
                 >
                   <IoMdArrowRoundBack className="text-xl group-hover:-translate-x-1 transition" />
                   <span className="hidden md:block">Back</span>
                 </button>
        </div>
        <h2 className="text-xl font-bold text-center hidden md:block text-[#36369f]">Create Questions</h2>
        <div className="md:text-xl text-sm font-semibold">
          Total Marks:{" "}
          <span className="font-extrabold text-red-500">
            {" "}
            {grandTotalMarks}{" "}
          </span>
        </div>
      </div>
      <h2 className="text-xl font-bold text-center block md:hidden pt-4">Create Questions</h2>
      <div className="w-11/12 mx-auto flex flex-col justify-items-center">
        
        {sections.subjective && (
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border mt-4">

 
  <div className="flex justify-between items-center bg-[#36369f] text-white px-6 py-3 ">
    <h3 className="font-semibold text-lg">Subjective Questions</h3>
    <p className="text-sm">Total Marks: {sectionMarks.subjective}</p>
  </div>

 
  <div className="divide-y">
    {subjectiveQuestions.map((question, index) => (
      <div
        key={index}
        className="flex items-start gap-4 px-4 md:px-6 py-4 hover:bg-gray-50 transition"
      >
        <p className="font-semibold text-[#36369f] mt-2">
          Q{index + 1}.
        </p>

        <textarea
          className="flex-1 border border-gray-200 focus:border-[#36369f] focus:ring-2 focus:ring-[#36369f]/20 outline-none p-3 rounded-xl shadow-sm text-sm md:text-base"
          placeholder="Enter your subjective question"
          value={question.question_text}
          onChange={(e) => handleTextChange(e, index, true)}
        />

        <p className="text-xs md:text-sm text-gray-500 mt-2 whitespace-nowrap">
          [{marksPerQuestion.subjective} marks]
        </p>
      </div>
    ))}
  </div>
</div>
        )}

        
        {sections.objective && (
         <div className="bg-white rounded-2xl shadow-lg overflow-hidden border mt-4">

 
  <div className="flex justify-between items-center bg-[#36369f] text-white px-6 py-3">
    <h3 className="font-semibold text-lg">Objective Questions</h3>
    <p className="text-sm">Total Marks: {sectionMarks.objective}</p>
  </div>

  
  <div className="divide-y">
    {objectiveQuestions.map((question, index) => (
      <div key={index} className="px-4 md:px-6 py-5 hover:bg-gray-50 transition">

        
        <div className="flex items-start gap-4">
          <p className="font-semibold text-[#36369f] mt-2">
            Q{index + 1}.
          </p>

          <textarea
            className="flex-1 border border-gray-200 focus:border-[#36369f] focus:ring-2 focus:ring-[#36369f]/20 outline-none p-3 rounded-xl shadow-sm"
            placeholder="Enter your objective question"
            value={question.question_text}
            onChange={(e) => handleTextChange(e, index, false)}
          />

          <p className="text-xs md:text-sm text-gray-500 mt-2 whitespace-nowrap">
            [{marksPerQuestion.objective} marks]
          </p>
        </div>

     
        <div className="grid md:grid-cols-2 gap-4 mt-6">
          {question.options.map((option, optIndex) => (
            <div key={optIndex} className="flex items-center gap-3 bg-gray-50 px-3 py-2 rounded-lg">
              
              <span className="font-semibold text-[#36369f]">
                {String.fromCharCode(65 + optIndex)}.
              </span>

              <input
                type="text"
                className="w-full bg-transparent outline-none"
                placeholder={`Option ${optIndex + 1}`}
                value={option}
                onChange={(e) =>
                  handleOptionChange(e, index, optIndex)
                }
              />
            </div>
          ))}
        </div>

       
        <div className="flex items-center gap-4 mt-6">
          <p className="font-semibold text-gray-600 text-sm md:text-base whitespace-nowrap">
            Correct Answer:
          </p>

          <input
            type="text"
            className="flex-1 border border-gray-200 focus:border-green-400 focus:ring-2 focus:ring-green-100 outline-none p-2 rounded-lg shadow-sm"
            placeholder="Enter correct answer"
            value={question.answer}
            onChange={(e) => handleAnswerChange(e, index)}
          />
        </div>
      </div>
    ))}
  </div>
</div>
)}

        <div className="mx-auto py-16">
          <button
            className="bg-gradient-to-r from-purple-600 to-pink-500 md:text-base text-sm text-white py-3 md:px-28 px-20 rounded-lg"
            onClick={handleSubmit}
          >
            Create Assessment
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelfCreateAssessmentPage3;